export default "__VITE_ASSET__CV1XoWPu__"